import React, { useEffect, useState } from 'react';
import { Link as Anchor } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faHome, 
    faSolarPanel, 
    faBolt,
    faLeaf,
    faShieldAlt, 
    faCheckCircle,
    faClock,
    faUserTie,
    faTools,
    faBatteryFull,
    faQuoteLeft,
    faPlug,
    faLightbulb,
    faHeadset,
    faMapMarkerAlt,
    faPhoneAlt,
    faStore,
    faWrench,
    faArrowRight,
    faGaugeHigh
} from '@fortawesome/free-solid-svg-icons';
import './HomePage.css';
import HeaderBack from '../../Components/HeaderBack/HeaderBack';

export default function HomePage() {
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        if (window.innerWidth <= 768) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        const handleScroll = () => {
            setScrollY(window.scrollY);
        };
        
        window.addEventListener('scroll', handleScroll);

        const lazyImages = [].slice.call(document.querySelectorAll("img.lazy-load"));
        
        if ("IntersectionObserver" in window) {
            const lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        const lazyImage = entry.target;
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.classList.remove("lazy-load");
                        lazyImage.classList.add("loaded");
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            }, {
                rootMargin: '200px 0px'
            });

            lazyImages.forEach(function(lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        } else {
            lazyImages.forEach(function(lazyImage) {
                lazyImage.src = lazyImage.dataset.src;
                lazyImage.classList.remove("lazy-load");
                lazyImage.classList.add("loaded");
            });
        }

        setImagesLoaded(true);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const productosVenta = [
        'Artefactos', 'Cables', 'Desarmadura', 'Llaves', 
        'Cuchillas', 'Termomagnéticas'
    ];

    const productosEspeciales = [
        'Aislante', 'Guantes', 'Luminarias en General', 
        'Accesorios eléctricos', 'Cargadores de Celulares', 'Parlantes'
    ];

    const serviciosTecnicos = [
        { nombre: 'Paneles Solares', icono: faSolarPanel },
        { nombre: 'Baterías', icono: faBatteryFull },
        { nombre: 'Controladores', icono: faPlug },
        { nombre: 'Inversores', icono: faBolt },
        { nombre: 'Conversores', icono: faGaugeHigh },
        { nombre: 'Accesorios', icono: faTools }
    ];

    return (
        <div className="nosotros-page">
             {/* Encabezado con imagen de fondo */}
            <div className='bgPage' style={{ 
                backgroundImage: imagesLoaded ? 
                    `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(/images/ban.jpg)` : 
                    'none',
                backgroundColor: imagesLoaded ? 'transparent' : 'var(--color1)'
            }}>
                <HeaderBack title='.:Inv Anahi:.' />
                <div className="breadcrumb">
                    <Anchor to="/">
                        <FontAwesomeIcon icon={faHome} /> Inicio
                    </Anchor>
                    <span>|</span>
                    <Anchor to=''>
                        Home
                    </Anchor>
                </div>
            </div>

            <div className="ProductsContainPage">
                <div className="nosotros-container" style={{ padding: '1.5rem' }}>
                    {/* Hero Section - Mensaje principal */}
                    <section className="hero-section" style={{ padding: '2.5rem 1.5rem', marginBottom: '2rem' }}>
                        <h1 style={{ fontSize: '2.2rem', marginBottom: '1rem' }}>Energías Perú - Inversiones Anahí</h1>
                        
                    </section>

                    {/* Nuestros Productos */}
                    <section className="info-section" style={{ padding: '1.8rem', marginBottom: '1.8rem' }}>
                        <div className="section-header" style={{ marginBottom: '1.5rem' }}>
                            <FontAwesomeIcon icon={faSolarPanel} className="section-icon" />
                            <h2 style={{ fontSize: '1.8rem' }}>Nuestros Productos</h2>
                        </div>
                        <div className="products-gallery" style={{ gap: '1.5rem' }}>
                            <div className="product-card" style={{ height: '260px' }}>
                                <div className="image-container">
                                    <img 
                                        data-src="/images/panel-solar.jpg" 
                                        alt="Paneles Solares" 
                                        className="product-image lazy-load"
                                    />
                                </div>
                                <div className="product-overlay">
                                    <h3>Paneles Solares</h3>
                                    <p>Alta eficiencia para hogar y negocio</p>
                                </div>
                            </div>
                            <div className="product-card" style={{ height: '260px' }}>
                                <div className="image-container">
                                    <img 
                                        data-src="/images/baterias.png" 
                                        alt="Baterías" 
                                        className="product-image lazy-load"
                                    />
                                </div>
                                <div className="product-overlay">
                                    <h3>Baterías y Controladores</h3>
                                    <p>Almacenamiento inteligente</p>
                                </div>
                            </div>
                            <div className="product-card" style={{ height: '260px' }}>
                                <div className="image-container">
                                    <img 
                                        data-src="/images/accesorios.jpg" 
                                        alt="Accesorios Eléctricos" 
                                        className="product-image lazy-load"
                                    />
                                </div>
                                <div className="product-overlay">
                                    <h3>Accesorios Eléctricos</h3>
                                    <p>Cables, termomagnéticas, luminarias</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Catálogo Completo - Basado en flyer */}
                    <section className="info-section" style={{ padding: '1.8rem', marginBottom: '1.8rem' }}>
                        <div className="section-header" style={{ marginBottom: '1.5rem' }}>
                            <FontAwesomeIcon icon={faStore} className="section-icon" />
                            <h2 style={{ fontSize: '1.8rem' }}>Catálogo Completo</h2>
                        </div>
                        
                        <div style={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', 
                            gap: '1.5rem' 
                        }}>
                            {/* VENTA DE */}
                            <div style={{
                                background: 'white',
                                borderRadius: '12px',
                                padding: '1.5rem',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                border: '1px solid #edf2f7'
                            }}>
                                <h3 style={{ 
                                    color: 'var(--color1)', 
                                    fontSize: '1.4rem',
                                    fontWeight: '700',
                                    marginBottom: '1.2rem',
                                    borderBottom: '3px solid var(--color2)',
                                    display: 'inline-block',
                                    paddingBottom: '0.3rem'
                                }}>
                                    VENTA DE
                                </h3>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    {productosVenta.map(item => (
                                        <li key={item} style={{ 
                                            padding: '0.6rem 0',
                                            borderBottom: '1px solid #f1f5f9',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.6rem',
                                            fontSize: '1rem'
                                        }}>
                                            <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'var(--color2)', fontSize: '0.85rem' }} />
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* ESPECIALIDADES */}
                            <div style={{
                                background: 'white',
                                borderRadius: '12px',
                                padding: '1.5rem',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                border: '1px solid #edf2f7'
                            }}>
                                <h3 style={{ 
                                    color: 'var(--color1)', 
                                    fontSize: '1.4rem',
                                    fontWeight: '700',
                                    marginBottom: '1.2rem',
                                    borderBottom: '3px solid var(--color2)',
                                    display: 'inline-block',
                                    paddingBottom: '0.3rem'
                                }}>
                                    ESPECIALIDADES
                                </h3>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    {productosEspeciales.map(item => (
                                        <li key={item} style={{ 
                                            padding: '0.6rem 0',
                                            borderBottom: '1px solid #f1f5f9',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.6rem',
                                            fontSize: '1rem'
                                        }}>
                                            <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'var(--color2)', fontSize: '0.85rem' }} />
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </section>

                    {/* Servicio Técnico */}
                    <section className="info-section" style={{ 
                        padding: '1.8rem',
                        marginBottom: '1.8rem',
                        background: 'linear-gradient(135deg, var(--color1), #0a4b4b)',
                        color: 'white'
                    }}>
                        <div className="section-header" style={{ marginBottom: '1.5rem' }}>
                            <FontAwesomeIcon icon={faWrench} className="section-icon" style={{ color: 'white' }} />
                            <h2 style={{ color: 'white', fontSize: '1.8rem' }}>SERVICIO TÉCNICO</h2>
                        </div>
                        
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                            gap: '1rem'
                        }}>
                            {serviciosTecnicos.map((servicio, index) => (
                                <div key={index} style={{
                                    background: 'rgba(255,255,255,0.1)',
                                    backdropFilter: 'blur(5px)',
                                    padding: '1.2rem 0.8rem',
                                    borderRadius: '12px',
                                    textAlign: 'center',
                                    border: '1px solid rgba(255,255,255,0.15)'
                                }}>
                                    <FontAwesomeIcon 
                                        icon={servicio.icono} 
                                        style={{ fontSize: '1.8rem', color: 'white', marginBottom: '0.5rem' }} 
                                    />
                                    <h3 style={{ color: 'white', fontSize: '1.1rem', marginBottom: '0.2rem', fontWeight: '600' }}>
                                        {servicio.nombre}
                                    </h3>
                                </div>
                            ))}
                        </div>
                        
                        <div style={{
                            textAlign: 'center',
                            marginTop: '1.8rem',
                            padding: '1rem',
                            background: 'rgba(255,255,255,0.08)',
                            borderRadius: '10px',
                            fontSize: '0.95rem'
                        }}>
                            <FontAwesomeIcon icon={faTools} style={{ marginRight: '0.5rem' }} />
                            Instalación • Mantenimiento • Reparación
                        </div>
                    </section>

                    {/* Contacto - Información del flyer */}
                    <section className="info-section" style={{
                        padding: '1.8rem',
                        background: 'white',
                        border: '2px solid var(--color1)'
                    }}>
                        <div className="section-header" style={{ marginBottom: '1.5rem' }}>
                            <FontAwesomeIcon icon={faHeadset} className="section-icon" />
                            <h2 style={{ fontSize: '1.8rem' }}>CONTACTOS</h2>
                        </div>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
                            gap: '2rem'
                        }}>
                            {/* Ubicación y Teléfonos */}
                            <div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.8rem',
                                    marginBottom: '1.5rem'
                                }}>
                                    <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: 'var(--color1)', fontSize: '1.3rem' }} />
                                    <p style={{ fontSize: '1rem', fontWeight: '600', color: '#333', lineHeight: '1.4' }}>
                                        JR. URUBAMBA MZ. 03 JR ENE.<br />
                                        <span style={{ fontSize: '0.9rem', color: '#666', fontWeight: 'normal' }}>Atalaya - Perú</span>
                                    </p>
                                </div>

                                <div style={{
                                    background: 'linear-gradient(135deg, var(--color1), #0a4b4b)',
                                    padding: '1.5rem',
                                    borderRadius: '16px',
                                    color: 'white'
                                }}>
                                    <h4 style={{ color: 'white', fontSize: '1.1rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                        <FontAwesomeIcon icon={faPhoneAlt} />
                                        Atención Inmediata
                                    </h4>
                                    
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                                        <a href="tel:966626906" style={{
                                            color: 'white',
                                            textDecoration: 'none',
                                            fontSize: '1.5rem',
                                            fontWeight: '700',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.8rem',
                                            background: 'rgba(255,255,255,0.1)',
                                            padding: '0.6rem 1rem',
                                            borderRadius: '10px'
                                        }}>
                                            <FontAwesomeIcon icon={faPhoneAlt} style={{ fontSize: '1rem' }} />
                                            966 626 906
                                        </a>
                                        <a href="tel:945976229" style={{
                                            color: 'white',
                                            textDecoration: 'none',
                                            fontSize: '1.5rem',
                                            fontWeight: '700',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.8rem',
                                            background: 'rgba(255,255,255,0.1)',
                                            padding: '0.6rem 1rem',
                                            borderRadius: '10px'
                                        }}>
                                            <FontAwesomeIcon icon={faPhoneAlt} style={{ fontSize: '1rem' }} />
                                            945 976 229
                                        </a>
                                    </div>
                                </div>
                            </div>

                            {/* Horarios */}
                            <div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.8rem',
                                    marginBottom: '1.5rem'
                                }}>
                                    <FontAwesomeIcon icon={faClock} style={{ color: 'var(--color1)', fontSize: '1.3rem' }} />
                                    <h3 style={{ color: '#333', fontSize: '1.2rem', margin: 0 }}>Horario de Atención</h3>
                                </div>

                                <div style={{
                                    background: '#f8fafc',
                                    padding: '1.5rem',
                                    borderRadius: '16px'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        padding: '0.8rem 0',
                                        borderBottom: '1px dashed #cbd5e0'
                                    }}>
                                        <span style={{ fontWeight: '600' }}>Lunes - Viernes</span>
                                        <span style={{ color: 'var(--color1)', fontWeight: '600' }}>8:00 am - 6:00 pm</span>
                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        padding: '0.8rem 0'
                                    }}>
                                        <span style={{ fontWeight: '600' }}>Sábados</span>
                                        <span style={{ color: 'var(--color1)', fontWeight: '600' }}>8:00 am - 12:00 pm</span>
                                    </div>
                                    
                                    <div style={{
                                        marginTop: '1.5rem',
                                        padding: '1rem',
                                        background: '#e6f7e6',
                                        borderRadius: '10px',
                                        textAlign: 'center'
                                    }}>
                                        <FontAwesomeIcon icon={faLeaf} style={{ color: 'var(--color2)', marginRight: '0.5rem' }} />
                                        <span style={{ fontSize: '0.95rem', color: '#2d3748' }}>
                                            Energía renovable para Atalaya
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}